import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { Store } from "vuex";
import { CreatePublicMeetingInterface } from "@api/models/interfaces/meetings/CreatePublicMeetingInterface";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import Vue from "vue";

export class MeetingHelper {
    private _isBusy = false;

    constructor(
        private readonly repository: MeetingRepository,
        private readonly component: Vue
    ) {}

    get isBusy() {
        return this._isBusy;
    }

    async createPublic(params: CreatePublicMeetingInterface) {
        if (this._isBusy || params.userIds.length === 0) { return; }

        this._isBusy = true;

        try {
            await this.repository.public(params);
        }
        catch (e) {
            await this.component.$store.dispatch('reportError', e);
            await this.notifyError();
        }
        finally {
            this._isBusy = false;
        }
    }

    async notifyError() {
        await this.component.$store.dispatch('notice/submitNotice', {
            text: this.component.$t('chat.meeting.error'),
            level: NoticeLevel.danger
        })
    }
}
